import { IAction } from '../../../__core/Interfaces/IAction';
import COURSE_INSTANCE_ACTIONS from '../Actions/ActionTypes';
import { instanceAccessForLecturesInitState } from './CourseInstanceInitState';
import { InstanceAccessResponse } from '../Types/InstanceAccessResponse';

export const instanceAccessForLecturesReducer = (
  state: InstanceAccessResponse = instanceAccessForLecturesInitState,
  action: IAction<InstanceAccessResponse>
): InstanceAccessResponse => {
  switch (action.type) {
    case COURSE_INSTANCE_ACTIONS.FETCH_INSTANCE_ACCESS_FOR_LECTURERS:
      return { ...action.payload };

    default:
      return state;
  }
};
